import axios from 'axios'
import {
  PRO_ROOT_URL,
  DEV_ROOT_URL,
} from '../variables'

import { store } from '../redux/store';
const DEFAULT_DOMAIN = 'public'


const clearDomain = domain => {
  const _domain = domain ||
    localStorage.getItem('domain') ||
    DEFAULT_DOMAIN

  if (
    _domain === 'undefined' ||
    _domain === DEFAULT_DOMAIN
  ) return ''
  return `${_domain}.`
}

const getRoot = () => {
  return process.env.APP_STAGE === 'development' ?
    DEV_ROOT_URL :
    PRO_ROOT_URL
}

const getUrl = domain => `https://${clearDomain(domain)}${getRoot()}`
const getBaseUrl = domain => `${getUrl(domain)}/api`;



const api = axios.create()

api.interceptors.request.use(
  config => {
    config.headers['tenant'] = localStorage.getItem('domain') || 'public'

    let sessionTokens = localStorage.getItem('tokens') || '{}'
    sessionTokens = JSON.parse(sessionTokens)
    if (sessionTokens['access-token']) {
      config.headers['access-token'] = sessionTokens['access-token']
      config.headers['client'] = sessionTokens['client']
      config.headers['uid'] = sessionTokens['uid']
    }
    config.baseURL = getBaseUrl()
    return config
  }
)

const doneHandler = response => {
  if (response?.headers['access-token']) {
    setTokens(response.headers)
  }
  return response
}

const errorHandler = error => {
  if (error.response && error.response.status === 401) {
    clearAuth();
    store.dispatch({ type: 'auth/logoutSuccess' });
    window.location.hash = '/login';
  }
  return Promise.reject(error)
}

api.interceptors.response.use(doneHandler, errorHandler)


const setTokens = tokens => localStorage.setItem('tokens', JSON.stringify(tokens))

const clearAuth = () => {
  localStorage.setItem('tokens', '{}')
  localStorage.setItem('domain', 'public')
}

// Invalidates the server-side auth token AND clears localStorage.
// Call this instead of clearAuth() when logging out intentionally so
// the old token cannot be replayed and the backend Devise session is
// terminated (which prevents the SSO "already signed in" redirect on
// the next login attempt in the dialog).
const signOut = () => {
  return api.delete('/auth/sign_out')
    .catch(() => {
      // Ignore errors (e.g. already expired token) – we still want
      // to clear local state regardless.
    })
    .finally(() => {
      clearAuth()
    })
}

export {
  api,
  getUrl,
  getBaseUrl,
  setTokens,
  clearAuth,
  signOut
}
